import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Divider} from '@/components/ui/divider/Divider'
import {CheckIcon, EyeIcon, ListCheckboxIcon, PlusIcon, QueueListIcon, XCloseIcon} from '@/components/ui/icon/Icon'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {Tab, Tabs} from '@/components/ui/tab-atoms/TabAtoms'
import {useTranslation} from '@/translations/i18n'
import {routes} from '@/utilities/constants/routes'
import {Helmet} from 'react-helmet'
import {Outlet} from 'react-router-dom'
import {StyledTreatmentRequestsTableLayoutWrapper} from './style'
import {usePermissions} from '@/features/auth/store/store'

export const TreatmentRequestsTableLayout = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()

    return (
        <StyledTreatmentRequestsTableLayoutWrapper>
            <Helmet title={t('treatment_requests:meta_title')} />
            <div>
                <PageHeading justify="space-between">
                    <h2>{t('treatment_requests:title')}</h2>
                    {permissions?.requests?.write && (
                        <ButtonLink variant="primaryNeutral" to={routes.CREATE_TREATMENT_REQUEST.path}>
                            <PlusIcon />
                            {t('commons:treatment_request')}
                        </ButtonLink>
                    )}
                </PageHeading>
                <Tabs paddingX={6}>
                    <Tab to={routes.TREATMENT_REQUESTS_IN_REVIEW.path}>
                        <EyeIcon />
                        {t('treatment_requests:status_in_review')}
                    </Tab>
                    <Tab to={routes.TREATMENT_REQUESTS_WAITING_LIST.path}>
                        <QueueListIcon />
                        {t('treatment_requests:status_waiting_list')}
                    </Tab>
                    <Tab to={routes.TREATMENT_REQUESTS_IN_PROGRESS.path}>
                        <ListCheckboxIcon />
                        {t('treatment_requests:status_in_progress')}
                    </Tab>
                    <Tab to={routes.TREATMENT_REQUESTS_ACCEPTED.path}>
                        <CheckIcon />
                        {t('treatment_requests:status_accepted', {count: 0})}
                    </Tab>
                    <Tab to={routes.TREATMENT_REQUESTS_REJECTED.path}>
                        <XCloseIcon />
                        {t('treatment_requests:status_rejected', {count: 0})}
                    </Tab>
                    <Divider height="auto" direction="vertical" startSpacing={4} endSpacing={4} />
                    <Tab to={routes.TREATMENT_REQUESTS_ROUTE.handle.path} end>
                        {t('treatment_requests:status_all')}
                    </Tab>
                </Tabs>
            </div>
            <Outlet />
        </StyledTreatmentRequestsTableLayoutWrapper>
    )
}
